import React from 'react';
import {Spin} from 'antd';
import {useNavigate, useParams} from 'react-router-dom';

const ProjectDetail: React.FC = () => {
	const {id} = useParams<{id: string}>();
	const navigate = useNavigate();

	React.useEffect(() => {
		navigate('/', {replace: true, state: id ? {openProjectId: Number(id)} : undefined});
	}, [id, navigate]);

	return (
		<div style={{display: 'flex', justifyContent: 'center', padding: 48}}>
			<Spin size="large" />
		</div>
	);
};

export default ProjectDetail;
